export const AppSettingConstant = {
    GET_APP_SETTING_SUCCESS: 'GET_APP_SETTING_SUCCESS',
    GET_APP_SETTING_FAILURE: 'GET_APP_SETTING_FAILURE',

    LANGUAGE_SWITCH: 'LANGUAGE_SWITCH',
};